import Player from '@vimeo/player';

export default function BGVideoHandler() {
    const videoContainer = document.querySelector('[data-video-bg]');

    if (videoContainer) {
        videoContainer.innerHTML = '';

        const player = new Player(videoContainer, {
            url: videoContainer.dataset.videoBg,
            // muted: true,
            background: true, // Auto-plays, loops, mutes, and removes controls
            responsive: true
        });
        player.setVolume(0);

        const playBtn = document.querySelector('[data-video-play]');
        const muteBtn = document.querySelector('[data-video-mute]');
        const fullBtn = document.querySelector('[data-video-full]');
        console.log(playBtn);
        playBtn.addEventListener('click', () => {
            player.getPaused().then(paused => {
                if (paused) {
                    player.play();
                } else {
                    player.pause();
                }
            });
            playBtn.classList.toggle('state2');
        });

        muteBtn.addEventListener('click', () => {
            player.getVolume().then(vol=> {
                if (vol > 0) {
                    player.setVolume(0);
                } else if (vol <= 0){
                    player.setVolume(1);
                }
            });
            muteBtn.classList.toggle('state2');
        });

        fullBtn.addEventListener('click', () => {
            player.requestFullscreen().catch(e => {
                console.log(e);
            });
        });
    }
}